import { EffectiveState, TimingEvent } from '@/gen/marketDataApi'
import { MarketState } from '@/gen/publicApi'

import { cn } from '@/utils/cn'

import { StatusCircle } from '../statusCircle'
import { Tooltip, TooltipContent, TooltipTrigger } from '../tooltip'

interface Props {
    className?: string
    state: MarketState
    lastTimingEvent: TimingEvent
    effectiveState: EffectiveState
}

const circles = {
    Enquiry: <StatusCircle variant="outline" />,
    Adjust: <StatusCircle variant="outline" />,
    Down: <StatusCircle variant="destructive" />,
    Auction: <StatusCircle variant="warning" />,
    Open: <StatusCircle variant="success" />,
}

export default function MarketStateCircle({ className, state, lastTimingEvent, effectiveState }: Props) {
    const Cmp = circles[effectiveState]

    return (
        <Tooltip>
            <TooltipTrigger>
                <div className={cn(className)}>{Cmp}</div>
            </TooltipTrigger>
            <TooltipContent>
                State: <span className="font-normal">{state}</span>
                <br />
                Last timing event: <span className="font-normal">{lastTimingEvent}</span>
                <br />
                Effective state: <span className="font-normal">{effectiveState}</span>
            </TooltipContent>
        </Tooltip>
    )
}
